import type { CalendarDisplayOrderData, CalendarGroupDisplayOrderData } from './DisplayOrderData';
import { getCalendarEntryByCalendarId, getCalendarGroupByGroupId } from 'owa-calendar-cache';

import type { LocalCalendarEntry } from 'owa-graph-schema';
import { convertEwsIdToRestId } from 'owa-identifiers';

export function getCalendarDisplayOrderData(
    draggedCalendarId: string,
    prevCalendarId: string,
    nextCalendarId: string,
    destGroupId: string,
    userIdentity: string
) {
    if (
        (!prevCalendarId && !nextCalendarId && !destGroupId) ||
        !userIdentity ||
        !draggedCalendarId
    ) {
        return null;
    }

    const displayOrderData: CalendarDisplayOrderData = {};

    if (prevCalendarId) {
        const prevCalendarEntry: LocalCalendarEntry = getCalendarEntryByCalendarId(
            prevCalendarId
        ) as LocalCalendarEntry;
        displayOrderData.PreviousDisplayOrder = prevCalendarEntry.DisplayOrder;
    }

    if (nextCalendarId) {
        const nextCalendarEntry: LocalCalendarEntry = getCalendarEntryByCalendarId(
            nextCalendarId
        ) as LocalCalendarEntry;
        displayOrderData.NextDisplayOrder = nextCalendarEntry.DisplayOrder;
    }

    const draggedCalendar: LocalCalendarEntry = getCalendarEntryByCalendarId(
        draggedCalendarId
    ) as LocalCalendarEntry;

    if (draggedCalendar.ParentGroupId !== destGroupId) {
        const destGroupItemId = getCalendarGroupByGroupId(destGroupId, userIdentity)
            ?.calendarGroupId.id;
        displayOrderData.CalendarGroupId = convertEwsIdToRestId(destGroupItemId);
    }

    return displayOrderData;
}

export function getGroupDisplayOrderData(
    prevGroupId: string,
    nextGroupId: string,
    userIdentity: string
) {
    if ((!prevGroupId && !nextGroupId) || !userIdentity) {
        return null;
    }

    const displayOrderData: CalendarGroupDisplayOrderData = {};
    const prevGroup = prevGroupId ? getCalendarGroupByGroupId(prevGroupId, userIdentity) : null;
    const nextGroup = nextGroupId ? getCalendarGroupByGroupId(nextGroupId, userIdentity) : null;

    if (prevGroup) {
        displayOrderData.PreviousDisplayOrder = prevGroup.DisplayOrder;
    }

    if (nextGroup) {
        displayOrderData.NextDisplayOrder = nextGroup.DisplayOrder;
    }

    return displayOrderData;
}
